<template>
  <span>
    <div class="boss-layout-block">
      <dl class="boss-scout-send-wrap cleafix">
        <dt class="boss-scout-send-left">テンプレート</dt>
        <dd class="boss-scout-send-right">
          <select
            :value="selectedTemplateId"
            class="boss-input-select"
            @change="setSelectedTemplateMessage($event.target.value, selectedTemplateId)"
          >
            <option
              :value="null"
              data-test="template-option-none"
            >
              指定なし
            </option>
            <option
              v-for="(template, i) in templates"
              :key="i"
              :data-test="'template-option-' + i"
              :value="template.id"
            >{{ template.name }}
            </option>
          </select>
        </dd>
        <dt class="boss-scout-send-left">
          件名
          <small>（200文字以内）</small>
        </dt>
        <dd class="boss-scout-send-right">
          <input
            v-model="message.subject"
            :class="{ 'is-invalid-input': hasTemplateReplacementCharacters(message.subject)}"
            class="boss-send-subject"
            type="text"
            data-test="message-subject"
          >
          <span
            v-if="hasTemplateReplacementCharacters(message.subject)"
            class="form-error is-visible margin-0"
            data-test="has-template-replacement-characters-subject"
          >「●●【」または「】●●」が入力フォームに残っていると、送信することができません</span>
        </dd>
        <dt class="boss-scout-send-left">本文<small>（12,000文字以内）</small></dt>
        <dd class="boss-scout-send-right">
          <div class="boss-textarea-button">
            <button
              v-tooltip="{ content: '本文にカーソルを合わせてクリックすると、■USER_NAME■ 様 と挿入されます。メッセージ送信時に自動的に応募者名に変換されます。'}"
              class="boss-button"
              data-test="user-name"
              @click="insertionValue('■USER_NAME■ 様')"
            >応募者名を挿入</button>
            <button
              v-tooltip="{ content: '本文にカーソルを合わせてクリックすると、■JOB_NAME■ と挿入されます。メッセージ送信時に自動的に応募求人名に変換されます。'}"
              class="boss-button"
              data-test="job-name"
              @click="insertionValue('■JOB_NAME■')"
            >求人名を挿入</button>
            <button
              v-tooltip="{ content: '本文にカーソルを合わせてクリックすると、社名が挿入されます。'}"
              class="boss-button"
              data-test="company-name"
              @click="insertionValue(currentUser.companyName)"
            >社名を挿入</button><span style="font-size: .8125rem;">（本文にのみ有効）</span>
          </div>
          <textarea
            ref="message"
            v-model="message.body"
            :class="{ 'is-invalid-input': hasTemplateReplacementCharacters(message.body)}"
            data-test="message-body"
            class="boss-send-textarea"
            rows
            cols
          />
          <span
            v-if="hasTemplateReplacementCharacters(message.body)"
            class="form-error is-visible margin-0"
            data-test="has-template-replacement-characters-body"
          >「●●【」または「】●●」が入力フォームに残っていると、送信することができません</span>
        </dd>
        <dt class="boss-scout-send-left">添付ファイル（任意）
        </dt>
        <dd class="boss-scout-send-right pega-message-tempfile-height">
          <template v-if="canFileUpload">
            <label
              :class="{'boss-send-file-disabled': isOverFiles}"
              data-test="file-label"
              class="boss-button boss-send-file"
            >
              <input
                ref="fileUpload"
                type="file"
                multiple="multiple"
                :disabled="isOverFiles"
                :accept="acceptTypes.toString()"
                data-test="file-upload"
                @change="changeFile($event.target.files)"
              >ファイルを選択
            </label>
            <ul class="boss-send-file-text">
              <span v-if="isUpload">アップロード中</span>
              <template v-else>
                <li
                  v-for="(file, i) in message.files"
                  :key="i"
                  class="boss-send-file-text-item"
                >{{ file.name }}<span
                  class="delete-icon"
                  @click="removeFile(i)"
                /></li>
              </template>
            </ul>
            <span class="boss-text pega-text-line-height">
              <div class="margin-top-05">
                ・1度にアップロードできるファイルは最大3ファイル、1ファイルの最大サイズは3MBです。
              </div>
              <div>
                ・応募者がファイルを閲覧・ダウンロードできる期間は送信日から30日間です。
              </div>
              <div class="boss-annotation-text">
                ・応募者側から、メッセージにてファイルを添付することはできません。
              </div>
              <div>
                ファイル形式（JPEG、JPG、PNG、PDF）のみ利用可能
              </div>
              <div>
                ファイル名に記号（!$&'()*+,;=%:@/?#~）は使用不可
              </div>
            </span>
          </template>
          <div
            v-else
            data-test="not-file-upload"
          >
            6名以上の一括送信にはファイル添付ができません。
          </div>
        </dd>
      </dl>
    </div>
    <div class="boss-layout-block">
      <accordion-table
        :is-opened="isAccordionOpen"
        :label="hasCandidateDate ? '応募時点の面接希望日あり' : '' "
        title="日程調整（任意）"
        @on-accordion-switch="onAccordionSwitch"
      >
        <div class="boss-table-2">
          <div class="boss-table-2-layout">
            <div class="boss-table-2-item boss-table-2-item-head">候補日時</div>
            <div class="boss-table-2-item boss-table-2-item-body boss-table-2-item-body-has-child">
              <div class="boss-table-2-layout">
                <div class="boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact candidate-head">応募者の希望日時</div>
                <div class="boss-table-2-item boss-table-2-item-body js-check-default-cell">
                  <div>
                    <div class="boss-layout-block">
                      <div class="boss-layout boss-layout-mobile-wrap boss-layout-start boss-layout-center">
                        <div v-if="hopeInterviewDateLabels.length">
                          <template v-for="(hopeInterviewDateLabel, i) in hopeInterviewDateLabels">
                            <label
                              :key="i"
                              :data-test="`hope-date-${ i }`"
                            >
                              {{ `第${ i + 1 }希望日時: ${ hopeInterviewDateLabel }` }}
                            </label>
                          </template>
                        </div>
                        <div
                          v-else
                          data-test="no-hope-date"
                        >
                          なし
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="boss-table-2-layout">
                <div class="boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact candidate-head">第一候補</div>
                <div class="boss-table-2-item boss-table-2-item-body js-check-default-cell">
                  <div>
                    <div class="boss-layout-block">
                      <div class="boss-layout boss-layout-mobile-wrap boss-layout-start boss-layout-center">
                        <div>
                          <label :class="{ 'pega-input': hasCandidateDate }">
                            <input
                              v-model="firstCandidateStatus"
                              :value="1"
                              :disabled="!hasCandidateDate"
                              type="radio"
                              name="schedule-1"
                              checked="checked"
                              class="boss-input-checkbox"
                              data-test="first-candidate-radio-first"
                            >応募者が提示している日程から選ぶ
                          </label>
                        </div>
                        <div>
                          <select
                            v-model="firstCandidateSelect"
                            :disabled="!hasCandidateDate || firstCandidateStatus !== 1"
                            data-test="first-candidate-select"
                            class="boss-input-select"
                          >
                            <option
                              v-if="!hasCandidateDate"
                              :value="null"
                              data-test="first-candidate-none"
                            >指定なし</option>
                            <option
                              v-if="hasCandidateDate"
                              :value="''"
                              data-test="first-candidate-top"
                            >選択して下さい</option>
                            <option
                              v-for="(option, i) in candidateOptions"
                              :key="i"
                              :value="option.value"
                              :data-test="'first-candidate-' + i "
                            >{{ option.name }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="boss-layout boss-layout-mobile-wrap boss-layout-start boss-layout-center">
                      <div>
                        <label class="pega-input">
                          <input
                            v-model="firstCandidateStatus"
                            :value="2"
                            type="radio"
                            name="schedule-1"
                            class="boss-input-checkbox"
                          >その他候補日時を入力
                        </label>
                      </div>
                      <div>
                        <date-picker
                          v-model="firstCandidateInput"
                          :disabled="firstCandidateStatus !== 2"
                          :minute-step="10"
                          type="datetime"
                          value-type="YYYY-MM-DDTHH:mm"
                          :disabled-date="notBeforeToday"
                          :disabled-time="notNightTime"
                          :editable="false"
                          :default-value="defaultValueInDaytime"
                          format="YYYY/MM/DD HH:mm"
                          input-class="pega-picker"
                          placeholder="日時を選択"
                          :style="{ width: 'auto' }"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="boss-table-2-layout">
                <div class="boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact candidate-head">第二候補
                  <br>（任意）
                </div>
                <div class="boss-table-2-item boss-table-2-item-body js-check-default-cell">
                  <div>
                    <div class="boss-layout-block">
                      <div class="boss-layout boss-layout-mobile-wrap boss-layout-start boss-layout-center">
                        <div>
                          <label :class="{ 'pega-input': hasCandidateDate }">
                            <input
                              v-model="secondCandidateStatus"
                              :value="1"
                              :disabled="!hasCandidateDate"
                              type="radio"
                              name="schedule-2"
                              class="boss-input-checkbox"
                              data-test="second-candidate-radio-first"
                            >応募者が提示している日程から選ぶ
                          </label>
                        </div>
                        <div>
                          <select
                            v-model="secondCandidateSelect"
                            :disabled="!hasCandidateDate || secondCandidateStatus !== 1"
                            data-test="second-candidate-select"
                            class="boss-input-select"
                          >
                            <option
                              v-if="!hasCandidateDate"
                              :value="null"
                              data-test="second-candidate-none"
                            >指定なし</option>
                            <option
                              v-if="hasCandidateDate"
                              :value="''"
                              data-test="second-candidate-top"
                            >選択して下さい</option>
                            <option
                              v-for="(option, i) in candidateOptions"
                              :key="i"
                              :value="option.value"
                              :data-test="'second-candidate-' + i "
                            >{{ option.name }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="boss-layout-block">
                      <div class="boss-layout boss-layout-mobile-wrap boss-layout-start boss-layout-center">
                        <div>
                          <label class="pega-input">
                            <input
                              v-model="secondCandidateStatus"
                              :value="2"
                              type="radio"
                              name="schedule-2"
                              class="boss-input-checkbox"
                            >その他候補日時を入力
                          </label>
                        </div>
                        <div>
                          <date-picker
                            v-model="secondCandidateInput"
                            :disabled="secondCandidateStatus !== 2"
                            :minute-step="10"
                            type="datetime"
                            :disabled-date="notBeforeToday"
                            :disabled-time="notNightTime"
                            :editable="false"
                            :default-value="defaultValueInDaytime"
                            value-type="YYYY-MM-DDTHH:mm"
                            format="YYYY/MM/DD HH:mm"
                            input-class="pega-picker"
                            placeholder="日時を選択"
                            :style="{ width: 'auto' }"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="boss-layout boss-layout-start boss-layout-center">
                      <div>
                        <label class="pega-input">
                          <input
                            v-model="secondCandidateStatus"
                            :value="3"
                            type="radio"
                            checked="checked"
                            name="schedule-2"
                            class="boss-input-checkbox"
                          >指定なし
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="boss-table-2-layout">
            <div class="boss-table-2-item boss-table-2-item-head">所要時間</div>
            <div class="boss-table-2-item boss-table-2-item-body">
              <select
                v-model="message.schedule.duration"
                data-test="duration"
                class="boss-input-select"
              >
                <option
                  v-for="(option, i) in minutesOptions"
                  :key="i"
                  :data-test="'duration-option-' + i "
                  :value="option"
                >{{ option }}
                </option>
              </select> 分
            </div>
          </div>
          <div class="boss-table-2-layout">
            <div class="boss-table-2-item boss-table-2-item-head">場所</div>
            <div class="boss-table-2-item boss-table-2-item-body">
              <label
                data-test="location"
                class="pega-input pega-break"
              >
                <input
                  v-model="isSelectedLocationDefault"
                  :value="true"
                  type="radio"
                  name="address"
                  class="boss-input-checkbox"
                  data-test="radio-location-default"
                >{{ location }}
              </label>
              <label class="pega-input">
                <input
                  v-model="isSelectedLocationDefault"
                  :value="false"
                  type="radio"
                  name="address"
                  data-test="other-location"
                  class="boss-input-checkbox"
                >その他
                <input
                  v-model="otherLocation"
                  :disabled="isSelectedLocationDefault"
                  type="text"
                  data-test="message-other-location"
                  class="boss-input"
                  size="30"
                  placeholder="その他を選択した場合は入力必須"
                >
              </label>
            </div>
          </div>
          <div class="boss-table-2-layout">
            <div class="boss-table-2-item boss-table-2-item-head">
              内容（複数選択可能）
              <br>（任意）
            </div>
            <div class="boss-table-2-item boss-table-2-item-body width-100">
              <div>
                <div class="boss-layout boss-layout-start boss-layout-gap-large boss-layout-wrap">
                  <label
                    v-for="(interviewContent, i) in interviewContentsMaster"
                    :key="i"
                    :data-test="'content-' + i "
                    class="pega-input"
                  >
                    <input
                      v-model="message.schedule.contentIds"
                      :value="interviewContent.id"
                      :data-test="'input-content-' + i "
                      type="checkbox"
                      class="boss-input-checkbox"
                    >{{ interviewContent.name }}
                  </label>
                  <label class="pega-input">
                    <input
                      v-model="isOtherContents"
                      type="checkbox"
                      class="boss-input-checkbox"
                      data-test="other-content"
                    >その他
                    <input
                      v-model="otherContents"
                      :disabled="!isOtherContents"
                      type="text"
                      class="boss-input"
                      data-test="message-other-content"
                      size="30"
                      placeholder="その他を選択した場合は入力必須"
                    >
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="boss-table-2-layout">
            <div class="boss-table-2-item boss-table-2-item-head">備考（任意）</div>
            <div class="boss-table-2-item boss-table-2-item-body">
              <textarea
                v-model="message.schedule.remarks"
                data-test="message-remarks"
                placeholder="持ち物、到着時の連絡先など"
                class="boss-textarea-in-table-2"
              />
            </div>
          </div>
        </div>
      </accordion-table>
    </div>
    <div class="boss-layout-block">
      <div class="boss-table-wrap">
        <div class="boss-table-2">
          <div class="boss-table-2-layout boss-table-2-layout-half">
            <div class="boss-table-2-layout">
              <div class="boss-table-2-item boss-table-2-item-head primary">選考フェーズ</div>
              <div class="boss-table-2-item boss-table-2-item-body">
                <label class="pega-input">
                  <input
                    v-model="message.isPhaseChange"
                    :value="true"
                    type="radio"
                    class="boss-input-checkbox"
                    data-test="do-update-phase"
                  >
                  <span data-test="do-update-phase-label">送信後</span>
                  <select
                    v-model="message.phaseId"
                    :disabled="!message.isPhaseChange"
                    class="boss-send-select-template"
                    data-test="select-update-phase"
                  >
                    <option
                      v-for="(phase ,i) in phases"
                      :key="i"
                      :value="phase.id"
                    >{{ phase.name }}
                    </option>
                  </select>
                  <span>に更新する</span>
                </label>
                <label class="pega-input">
                  <input
                    v-model="message.isPhaseChange"
                    :value="false"
                    type="radio"
                    class="boss-input-checkbox"
                    data-test="do-not-update-phase"
                  >
                  <span data-test="do-not-update-phase-label">更新しない</span>
                </label>
              </div>
            </div>
          </div>
          <div class="boss-table-2-layout boss-table-2-layout-half">
            <div class="boss-table-2-layout">
              <div class="boss-table-2-item boss-table-2-item-head primary">選考ステータス</div>
              <div class="boss-table-2-item boss-table-2-item-body">
                <label class="pega-input">
                  <input
                    v-model="message.isStatusChange"
                    :value="true"
                    type="radio"
                    class="boss-input-checkbox"
                    data-test="do-update-status"
                  >
                  <span data-test="do-update-status-label">送信後</span>
                  <select
                    v-model="message.statusId"
                    :disabled="!message.isStatusChange"
                    class="boss-send-select-template"
                    data-test="select-update-status"
                  >
                    <option :value="null">―</option>
                    <option
                      v-for="(status ,i) in allStatuses"
                      :key="i"
                      :value="status.id"
                    >{{ status.name }}
                    </option>
                  </select>
                  <span>に更新する</span>
                </label>
                <label class="pega-input">
                  <input
                    v-model="message.isStatusChange"
                    :value="false"
                    type="radio"
                    class="boss-input-checkbox"
                    data-test="do-not-update-status"
                  >
                  <span data-test="do-not-update-status-label">更新しない</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="boss-layout-block">
      <p class="boss-text">※「選考フェーズ、選考ステータス」は応募者側では表示されません。</p>
    </div>
    <div class="boss-layout boss-layout-center">
      <button
        :disabled="hasErrors"
        data-test="confirmation"
        class="boss-button boss-button-confirm pega-button"
        @click="onConfirmClick"
      >
        <span class="boss-button-confirm-text">送信内容を確認する</span>
      </button>
    </div>
  </span>
</template>

<script>
import * as definition from '@/lib/labelValueMappings'
import AccordionTable from '@/components/atoms/AccordionTable'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import { createDate, now } from '@/lib/dateUtils.js'
import DatePicker from 'vue2-datepicker'
import datePickerFunction from '@/lib/datePickerFunction.js'

export default {
  components: {
    AccordionTable,
    DatePicker
  },
  mixins: [datePickerFunction],
  props: {
    value: {
      type: Object,
      required: true
    },
    entryIds: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      date: '',
      message: this.value,
      otherLocation: '',
      location: '',
      minutesOptions: definition.durationTimeMinutes,
      hopeInterviewDates: [],
      firstCandidateStatus: 2, // 1: 日程から選ぶ, 2: その他候補
      isSkipWatchFirstCandidateStatus: false,
      secondCandidateStatus: 3, // 1: 日程から選ぶ, 2: その他候補, 3: 指定しない
      isSkipWatchSecondCandidateStatus: false,
      isSelectedLocationDefault: true,
      isOtherContents: false,
      otherContents: '',
      firstCandidate: '',
      secondCandidate: '',
      isAccordionOpen: false,
      templates: [],
      selectedTemplateId: null,
      isUpload: false
    }
  },
  computed: {
    maxFiles: () => 3,
    maxFileSize: () => 1024 * 1024 * 3,
    hasTemplateReplacementCharacters () {
      return (val) => {
        return /●●【|】●●/.test(val)
      }
    },
    isEmpty () {
      return (val) => {
        return !_.isDate(val) && _.isEmpty(val)
      }
    },
    ...mapGetters([
      'currentUser',
      'interviewContentsMaster'
    ]),
    ...mapGetters('settings', [
      'phases',
      'allStatuses'
    ]),
    candidateOptions () {
      return _(this.hopeInterviewDates).map(interviewDate => {
        const dateTimes = []
        for (let target = createDate(interviewDate.from); target?.isBefore(createDate(interviewDate.to)); target = target.add(1, 'hours')) {
          dateTimes.push({
            name: target.format('YYYY/MM/DD HH:mm'),
            value: target.format('YYYY-MM-DDTHH:mm')
          })
        }
        return dateTimes
      }).flattenDeep().uniqBy('value').value()
    },
    hasCandidateDate () {
      return !_.isEmpty(this.hopeInterviewDates)
    },
    firstCandidateSelect: {
      get () {
        return (this.firstCandidateStatus === 1) ? this.firstCandidate : null
      },
      set (val) {
        this.$set(this, 'firstCandidate', (val) || '')
      }
    },
    firstCandidateInput: {
      get () {
        return (this.firstCandidateStatus === 2) ? this.firstCandidate : null
      },
      set (val) {
        this.$set(this, 'firstCandidate', createDate(val)?.format('YYYY-MM-DDTHH:mm') ?? '')
      }
    },
    secondCandidateSelect: {
      get () {
        return (this.secondCandidateStatus === 1) ? this.secondCandidate : null
      },
      set (val) {
        this.$set(this, 'secondCandidate', createDate(val)?.format('YYYY-MM-DDTHH:mm') ?? '')
      }
    },
    secondCandidateInput: {
      get () {
        return (this.secondCandidateStatus === 2) ? this.secondCandidate : null
      },
      set (val) {
        this.$set(this, 'secondCandidate', createDate(val)?.format('YYYY-MM-DDTHH:mm') ?? '')
      }
    },
    hasErrors () {
      const validationItems = [
        {
          value: this.message.subject, isRequired: true
        },
        {
          value: this.message.body, isRequired: true
        }
      ]
      this.isAccordionOpen && validationItems.push(
        {
          value: this.message.schedule.remarks, length: 200
        },
        {
          value: this.message.schedule.candidateDates[0], isRequired: true
        },
        {
          value: this.message.schedule.place, isRequired: true
        },
        {
          value: this.otherContents, isRequired: this.isOtherContents
        }
      )
      return _.some(validationItems, item => {
        return (_.get(item, 'isRequired') && this.isEmpty(item.value)) ||
        this.hasTemplateReplacementCharacters(item.value)
      }) || _.isNull(this.message.isPhaseChange) || _.isNull(this.message.isStatusChange) || this.isUpload
    },
    hopeInterviewDateLabels () {
      return _.map(_.take(this.hopeInterviewDates, 5), o => {
        const isSameDay = createDate(o.from)?.isSame(o.to, 'day')
        return `${createDate(o.from)?.format('YYYY/MM/DD HH:mm')} 〜 ${(isSameDay) ? createDate(o.to)?.format('HH:mm') : createDate(o.to)?.format('YYYY/MM/DD HH:mm')}`
      })
    },
    acceptTypes: () => ['image/jpeg', 'image/png', 'application/pdf'],
    canFileUpload () {
      return this.entryIds.length <= 5
    },
    isOverFiles () {
      return this.message.files.length >= this.maxFiles
    }
  },
  watch: {
    value (val) {
      this.$set(this, 'message', val)
      // 初期値指定
      if (!this.message.schedule.duration) {
        this.$set(this.message.schedule, 'duration', this.minutesOptions[0])
      }
      if (this.message.schedule.isUseCompanyAddress) {
        this.$set(this.message.schedule, 'place', this.location)
      }
      // 選考日時ご案内フォーマットを利用する場合、第一候補日は必須
      if (val.schedule.candidateDates.length) {
        // 選考日時ご案内フォーマットの内容を反映
        this.onAccordionSwitch(true)
        // 候補日時
        // - 過去日は除外
        this.$set(this.message.schedule, 'candidateDates', val.schedule.candidateDates.filter(date => createDate(date).isAfter(now())))
        // 候補日時 - 第一候補
        if (val.schedule.candidateDates[0]) {
          this.$set(this, 'isSkipWatchFirstCandidateStatus', true)
          this.$set(this, 'firstCandidateStatus', 2) // その他候補日固定
          this.$set(this, 'firstCandidateInput', val.schedule.candidateDates[0])
        }
        // 候補日時 - 第二候補
        if (val.schedule.candidateDates[1]) {
          this.$set(this, 'isSkipWatchSecondCandidateStatus', true)
          this.$set(this, 'secondCandidateStatus', 2) // その他候補日固定
          this.$set(this, 'secondCandidateInput', val.schedule.candidateDates[1])
        }
        // 場所
        this.$set(this, 'isSelectedLocationDefault', val.schedule.isUseCompanyAddress)
        if (!val.schedule.isUseCompanyAddress) {
          this.$set(this, 'otherLocation', val.schedule.place)
        }
        // 内容 - その他
        if (val.schedule.otherContents) {
          this.$set(this, 'isOtherContents', true)
          this.$set(this, 'otherContents', val.schedule.otherContents)
        }
      }
    },
    hopeInterviewDates (val) {
      this.$set(this, 'firstCandidateStatus', _.isEmpty(val) ? 2 : 1)
    },
    firstCandidateStatus () {
      if (this.isSkipWatchFirstCandidateStatus) {
        // 1回だけskip
        this.$set(this, 'isSkipWatchFirstCandidateStatus', false)
        return
      }
      this.$set(this, 'firstCandidate', null)
    },
    secondCandidateStatus () {
      if (this.isSkipWatchSecondCandidateStatus) {
        // 1回だけskip
        this.$set(this, 'isSkipWatchSecondCandidateStatus', false)
        return
      }
      this.$set(this, 'secondCandidate', null)
    },
    isSelectedLocationDefault (val) {
      _.set(this.message, 'schedule.isUseCompanyAddress', val)
      const place = (val) ? this.location : this.otherLocation
      _.set(this.message, 'schedule.place', place)
    },
    otherLocation (val) {
      _.set(this.message, 'schedule.place', val)
    },
    isOtherContents (val) {
      _.set(this.message, 'schedule.otherContents', val ? this.otherContents : '')
    },
    otherContents (val) {
      _.set(this.message, 'schedule.otherContents', this.isOtherContents ? val : '')
    },
    firstCandidate () {
      this.$set(this.message.schedule, 'candidateDates', _.compact([this.firstCandidate, this.secondCandidate]))
    },
    secondCandidate () {
      this.$set(this.message.schedule, 'candidateDates', _.compact([this.firstCandidate, this.secondCandidate]))
    },
    candidateOptions (val) {
      if (val && val.length) {
        this.$set(this, 'firstCandidate', _.head(val).value)
      }
    },
    $route: {
      handler () {
        this.$route.params.entryId && this.fetchHopeInterviewDates()
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.fetchCompanyPlace()
      if (this.$route.params.entryId) {
        this.fetchHopeInterviewDates()
      } else {
      // 一括送信の場合、候補者を特定できないので空とする
        this.$set(this, 'hopeInterviewDates', [])
      }
      this.$set(this.message.schedule, 'duration', this.minutesOptions[0])
      this.fetchTemplates()
    },
    insertionValue (value) {
      const cursorPosition = this.$refs.message.selectionStart
      this.$set(this.message, 'body', this.message.body.substr(0, cursorPosition) + value + this.message.body.substr(cursorPosition, this.message.body.length))
    },
    onAccordionSwitch (val) {
      this.$set(this, 'isAccordionOpen', val)
    },
    onConfirmClick () {
      this.$emit('filledOut', this.isAccordionOpen)
      this.$scrollTo('#message-register', 0, { offset: -35 })
    },
    fetchTemplates () {
      this.$http.secured.get('/company/entry/message/templates/_display').then(response => {
        this.$set(this, 'templates', response.data)
      })
    },
    fetchTemplate () {
      this.$http.secured.get(`/company/entry/message/templates/${this.selectedTemplateId}`).then(response => {
        const template = response.data
        this.$set(this.message, 'body', template.body)
        this.$set(this.message, 'subject', template.subject)
      })
    },
    setSelectedTemplateMessage (newId, oldId) {
      if (!newId) {
        // 「指定なし」が選択された場合は、selectedTemplateIdのみ更新
        this.$set(this, 'selectedTemplateId', null)
        return
      }

      if (!this.message.subject && !this.message.body) {
        // 件名・本文が未入力の場合にテンプレートが変更された場合は、テンプレートを反映
        this.$set(this, 'selectedTemplateId', newId)
        this.fetchTemplate()
        return
      }

      // 件名 または 本文が入力済みの場合にテンプレートが変更された場合は、確認ダイアログを出す
      this.$dialog.confirm('現在入力している件名・本文が削除されます。テンプレートを適応してよろしいですか？')
        // はいを押下した時：テンプレートを反映
        .then(() => {
          this.$set(this, 'selectedTemplateId', newId)
          this.fetchTemplate()
        })
        // いいえを押下した時：選択前の値に戻す
        .catch(() => {
          // 一度空更新しないと、同一の値とみなされてselectに反映されないため、空更新してからoldIdを連携
          this.$set(this, 'selectedTemplateId', '')
          this.$set(this, 'selectedTemplateId', oldId)
        })
    },
    fetchCompanyPlace () {
      this.$http.secured.get('/company').then(response => {
        this.$set(this, 'location', response.data.place)
        _.set(this.message, 'schedule.place', response.data.place)
      })
    },
    fetchHopeInterviewDates () {
      this.$http.secured.get(`/entry/view/entries/${this.$route.params.entryId}/hope_interview_dates`).then(response => {
        this.$set(this, 'hopeInterviewDates', response.data)
      })
    },
    reset () { // 親からrefsで呼ばれるメソッド
      this.$set(this, 'date', '')
      this.$set(this, 'otherLocation', '')
      this.$set(this, 'location', '')
      this.$set(this, 'hopeInterviewDates', [])
      this.$set(this, 'firstCandidateStatus', 2)
      this.$set(this, 'secondCandidateStatus', 3)
      this.$set(this, 'isSelectedLocationDefault', true)
      this.$set(this, 'isOtherContents', false)
      this.$set(this, 'otherContents', '')
      this.$set(this, 'firstCandidate', '')
      this.$set(this, 'secondCandidate', '')
      this.$set(this, 'isAccordionOpen', false)
      this.$set(this, 'templates', [])
      this.$set(this, 'selectedTemplateId', null)
      this.init()
    },
    changeFile (filesData) {
      const files = Array.from(filesData)
      if (this.hasFilesError(files, this.message.files.length) || !files.length) return
      this.$set(this, 'isUpload', true)
      const config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
      const formData = new FormData()
      files.forEach(file => {
        formData.append('files', file)
      })
      this.entryIds.forEach(entryId => {
        formData.append('entryIds', entryId)
      })
      this.$http.secured.post('/entry/message/send/file_upload', formData, config).then((response) => {
        // 読み込んだファイルとレスポンスファイル情報順番の確認
        // 結合文字は区別したくないので、normalizeして比較する
        if (response.data.every((uploadFile, index) =>
          _.isEqual(
            [uploadFile.name.normalize(), uploadFile.byteSize],
            [files[index].name.normalize(), files[index].size]
          )
        )) {
          this.message.files.push(...response.data)
        } else {
          this.$toasted.global.error({ message: 'ファイルアップロードに失敗しました。再度選択してください。' })
        }
      }).finally(() => {
        this.$set(this, 'isUpload', false)
        this.resetRefsFileUpload()
      })
    },
    removeFile (index) {
      this.message.files.splice(index, 1)
      this.resetRefsFileUpload()
    },
    resetRefsFileUpload () {
      this.$refs.fileUpload.value = ''
    },
    hasFilesError (files, uploadedFilesLength) {
      if ((files.length + uploadedFilesLength) > this.maxFiles) {
        this.$toasted.global.error({ message: '最大３ファイルまでしかアップロードできません。' })
        return true
      } else if (files.some(file => file.size > this.maxFileSize)) {
        this.$toasted.global.error({ message: '最大３MBのサイズまでしかアップロードできません。' })
        return true
      } else if (!files.every(file => this.acceptTypes.includes(file.type))) {
        this.$toasted.global.error({ message: 'JPEG、JPG、PNG、PDF以外のファイルはアップロードできません。' })
        return true
      }
      return false
    }
  }
}
</script>
